import { Component, Input, OnDestroy, OnInit, Optional } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { NavService } from "../../../_services/_nav.service";
import { ProductosFlujoVentaPasosService } from "../../../_services/productos-flujo-venta-pasos.service";
import { PreAprobadosService } from "../../../_services/pre-aprobados.service";
import { PreAprobadosOfertasService } from "../../../_services/pre-aprobados-ofertas.service";
import { SimuladorOfertaService } from "../../../_services/simulador-oferta.service";
import { ProductoService } from "../../../_services/producto.service";
import { ProductoFrecuenciaService } from "../../../_services/producto-frecuencia.service";
import { ProductoSeguroAnalizamosService } from "../../../_services/producto-seguro-analizamos.service";
import { SeguroPlanService } from "../../../_services/seguro-plan.service";
import { ConstanteService } from "../../../_services/constante.service";
import { ListaService } from "../../../_services/lista.service";
import { ComunicationComponentsService } from "../../../_services/comunication-components.service";
import { TranslateService } from '@ngx-translate/core';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { CanalService } from '../../../_services/canal.service';
import { ConfiguracionesCanalesService } from '../../../_services/configuraciones-canales.service';
import {
  CampoOrdenGestorPreaprobados,
  SolicitudGestorPreaprobado,
  CanalPreAprobado
} from "../../../_models/pre-aprobados";
import { CancelacionPreaprobado, PreAprobadosOfertas } from "../../../_models/pre-aprobados-ofertas";
import { SolicitudesPreOferta } from "../../../_models/solicitudes-pre-oferta";
import { Producto } from "../../../_models/producto";
import { ProductoFrecuencia } from "../../../_models/producto-frecuencia";
import { CodigoCanales, TiposPreaprobados } from "../../../_enums/enum";

@Component({
  selector: "app-gestion-comercial-preaprobado",
  templateUrl: "./gestion-comercial-preaprobado.component.html",
  styleUrls: ["./gestion-comercial-preaprobado.component.scss"],
})
export class GestionComercialPreaprobadoComponent implements OnInit, OnDestroy {
  @Input() esModal: boolean = false;
  @Input() sinNavegacion: boolean = false;
  @Input() datosClienteInput: { nombre: string; tipoDocumento: string; numeroDocumento: string; tieneWallet: boolean; estadoWallet: string; vigenciaHasta: string; codigoTipoDocumento: string; } | null = null;
  @Input() registroInput: any = null;
  @Input() perfilCrezcamos: boolean = false;
  // M4477 - Solo el flujo de venta lo activa para no mostrar ofertas cuyo producto no está vigente
  validarVigenciaProducto: boolean = false;

  canalesPermitidos: string[] = [];

  // Tabla
  ofertasFiltradas: SolicitudGestorPreaprobado[] = [];
  textoBusqueda: string = '';
  cargando: boolean = false;
  cargandoInicial: boolean = true;
  totalRegistros: number = 0;
  readonly filasPorPagina = 4;

  // Orden
  campoOrden: CampoOrdenGestorPreaprobados = 'monto';
  ordenAscendente: boolean = false;

  // Simulador
  ofertaSimulando: SolicitudGestorPreaprobado | null = null;
  montosDisponibles: { label: string; value: number }[] = [];
  valorCuota: number = 0;
  simulacionCalculada: boolean = false;
  formSimulador: FormGroup;
  submitted: boolean = false;
  calculando: boolean = false;
  bloqueo: boolean = false;
  cargandoSimulador: boolean = false;
  tasaOferta: number = 0;

  // Datos del simulador cargados desde servicios
  producto: Producto;
  rangoMonto: string = '';
  maxCuotas: number = 0;
  minCuotas: number = 0;
  maxMontoVal: number = 0;
  minMontoVal: number = 0;
  private frecuencias: ProductoFrecuencia[] = [];
  private listPreAprobadosOfertaTemp: PreAprobadosOfertas[] = [];
  private salario: number = 0;
  // Última oferta seleccionada por simulación (key: idPreAprobado)
  private ultimaOfertaSeleccionada: Map<string, PreAprobadosOfertas> = new Map();
  // Datos de preoferta de la última simulación guardada (key: idPreAprobado)
  private ultimaPreofertaSimulada: Map<string, Partial<SolicitudesPreOferta>> = new Map();
  private diaSemanal: number = 0;
  private idSeguroObligatorio: string[] = [];
  private idPlanObligatorio: string[] = [];

  listFrecuencias: { label: string; value: string }[] = [];

  // Modal rechazo
  mostrarModalRechazo: boolean = false;
  ofertaArechazar: SolicitudGestorPreaprobado | null = null;
  readonly maxCaracteresComentario = 500;
  formRechazo: FormGroup;
  submittedRechazo: boolean = false;

  ListasCausalesCancelaciones: { value: string; label: string }[] = [];
  billeteraActiva: boolean = false;
  readonly CodigoCanales = CodigoCanales;
  readonly TiposPreaprobados = TiposPreaprobados;
  datosCliente: { nombre: string; tipoDocumento: string; numeroDocumento: string; tieneWallet: boolean; estadoWallet: string; vigenciaHasta: string; codigoTipoDocumento: string; indicadorTienePreaprobados: boolean } = {
    nombre: '',
    tipoDocumento: '',
    numeroDocumento: '',
    tieneWallet: false,
    estadoWallet: '',
    vigenciaHasta: '',
    codigoTipoDocumento: '',
    indicadorTienePreaprobados: false
  };

  get fSimulador(): { [key: string]: AbstractControl } { return this.formSimulador.controls; }
  get fRechazo()   { return this.formRechazo.controls;   }

  constructor(
    @Optional() private ref: DynamicDialogRef,
    @Optional() private config: DynamicDialogConfig,
    private navService: NavService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private preAprobadosService: PreAprobadosService,
    private preAprobadosOfertasService: PreAprobadosOfertasService,
    private simOfertaService: SimuladorOfertaService,
    private productoService: ProductoService,
    private productoFrecuenciaService: ProductoFrecuenciaService,
    private productoSeguroService: ProductoSeguroAnalizamosService,
    private seguroPlanService: SeguroPlanService,
    private constanteService: ConstanteService,
    private listaService: ListaService,
    private fb: FormBuilder,
    private translateService: TranslateService,
    private comComponentsService: ComunicationComponentsService,
    private router: Router,
    private proFlujoVentaService: ProductosFlujoVentaPasosService,
    private autServicio: AutenticacionService,
    private canServicio: CanalService,
    private conCanalesService: ConfiguracionesCanalesService,
  ) { }

  ngOnInit(): void {
    if (this.config?.data?.esModal) {
      this.esModal = true;
      this.sinNavegacion = this.config?.data?.sinNavegacion ?? false;
      this.perfilCrezcamos = this.config?.data?.perfilCrezcamos;
      // M4477 - Indicador enviado por el flujo de venta
      this.validarVigenciaProducto = !!this.config?.data?.validarVigenciaProducto;
    }
    this.comComponentsService.resetearDatosPreaprobado();
    this.initForms();
    this.cargarDatosCliente();
    this.cargarCanalesPermitidos();
    this.listaService.getMasterDetails('ListasCausalesCancelacionesPreaprobados').subscribe(causales => {
      this.ListasCausalesCancelaciones = causales.map(cc => ({ value: cc.idLista, label: cc.nombre }));
    });
  }

  ngOnDestroy(): void {
    this.comComponentsService.resetearDatosPreaprobado();
  }

  private cargarCanalesPermitidos(): void {
    forkJoin([
      this.canServicio.listadoCanalesUsuario(this.autServicio.obtenerIdUsuarioLogueado()),
      this.conCanalesService.listadoHabilitados()
    ]).subscribe({
      next: ([listaCanales, lisConfiguracionCanal]) => {
        this.canalesPermitidos = (listaCanales || [])
          .filter((canal: any) => !!lisConfiguracionCanal.find((x: any) => x.idCanal === canal.idCanal))
          .map((canal: any) => canal.idCanal);
      },
      error: () => {
        this.canalesPermitidos = [];
      }
    });
  }

  private initForms(): void {
    this.formSimulador = this.fb.group({
      monto:           [null, Validators.required],
      plazo:           [null],
      idFrecuencia:    [null],
      numeroCuota:     [null, [Validators.required, Validators.min(1)]],
      diaPago:         [null],
    });

    this.formRechazo = this.fb.group({
      causal:     [null, Validators.required],
      comentario: ['', Validators.maxLength(this.maxCaracteresComentario)],
    });
  }

  private cargarDatosCliente(): void {
    // Prioridad 1: datosCliente completo (modal o @Input)
    const datosCompletos = this.config?.data?.datosCliente ?? this.datosClienteInput;
    if (datosCompletos) {
      this.datosCliente = datosCompletos;
      return;
    }

    // Prioridad 2: registro con campos sueltos (modal o @Input)
    const reg = this.config?.data?.registro ?? this.registroInput;
    if (reg) {
      const codigo: string = reg.codigoDocumento ?? reg.codigoTipoDocumentoTerceroSolicitante ?? reg.codigoTipoDocumento ?? '';
      this.datosCliente = {
        nombre:               reg.nombreCompleto ?? `${reg.primerNombreTerceroSolicitante ?? ''} ${reg.primerApellidoTerceroSolicitante ?? ''}`.trim(),
        tipoDocumento:        codigo ? `${codigo}.` : '',
        codigoTipoDocumento:  codigo,
        numeroDocumento:      reg.documento ?? reg.numeroDocumento ?? '',
        tieneWallet:          false,
        estadoWallet:         '',
        vigenciaHasta:        '',
        indicadorTienePreaprobados: false
      };
    }
  }

  cargarOfertas(pagina: number, cantidad: number): void {
    if (!this.datosCliente) return;
    this.cargando = true;

    this.preAprobadosService.buscadorSolicitudesGestorPreaprobados({
      campoAOrdenarSql: this.campoOrden,
      indicadorOrdenarAscendente: this.ordenAscendente,
      search: this.textoBusqueda?.trim() || null,
      numeroDocumento: this.datosCliente.numeroDocumento,
      codigoTipoDocumento: this.datosCliente.codigoTipoDocumento,
      pagina,
      cantidad,
      // M4477 - El back excluye las ofertas cuyo producto no está vigente solo si viene en true
      validarVigenciaProducto: this.validarVigenciaProducto,
    }).subscribe({
      next: (rta) => {
        this.ofertasFiltradas = rta.data;
        this.totalRegistros = rta.total;
        this.datosCliente.tieneWallet = rta.indicadorResgitradoBilletera;
        this.datosCliente.indicadorTienePreaprobados = rta.indicadorTienePreaprobados;
        this.datosCliente.vigenciaHasta = rta.fechaMaximaVigencia;
        this.comComponentsService.emitirDatosPreaprobado({
          tieneWallet: !!rta.indicadorResgitradoBilletera,
          indicadorTienePreaprobados: !!rta.indicadorTienePreaprobados,
        });
        this.cargando = false;
        this.cargandoInicial = false;
      },
      error: () => {
        this.ofertasFiltradas = [];
        this.totalRegistros = 0;
        this.cargando = false;
        this.cargandoInicial = false;
      },
    });
  }

  onLazy(event: any): void {
    const pagina = event.first / (event.rows || this.filasPorPagina);
    const cantidad = event.rows || this.filasPorPagina;

    if (event.sortField) {
      this.campoOrden = event.sortField as CampoOrdenGestorPreaprobados;
      this.ordenAscendente = event.sortOrder === 1;
    }

    this.cargarOfertas(pagina, cantidad);
  }

  tieneCanal(oferta: SolicitudGestorPreaprobado, codigoCanal: string): boolean {
    return oferta.canales?.some(c => c.codigo === codigoCanal) ?? false;
  }

  tieneCanalesAsesor(oferta: SolicitudGestorPreaprobado): boolean {
    const canalesValidos = oferta.canales?.filter(
      c => c.codigo !== this.CodigoCanales.DIGITAL && c.codigo !== this.CodigoCanales.WALLET
    ) || [];

    return canalesValidos.some(c => this.canalesPermitidos.includes(c.idCanal));
  }

  ordenarCanales(canales?: CanalPreAprobado[]): CanalPreAprobado[] {
    if (!canales || canales.length === 0) return [];
    return [...canales].sort((a, b) => {
      const ordenA = a.orden != null ? a.orden : 999;
      const ordenB = b.orden != null ? b.orden : 999;
      return ordenA - ordenB;
    });
  }

  filtrar(): void {
    const texto = this.textoBusqueda.trim();
    if (texto.length === 0 || texto.length >= 3) {
      this.cargarOfertas(0, this.filasPorPagina);
    }
  }

  formatMonto(valor: number): string {
    if (valor === null || valor === undefined || isNaN(valor)) {
      return '$0'; // o el valor por defecto que quieras mostrar
    }
    return '$' + valor.toLocaleString('es-CO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });  }

  formatVencimiento(fecha: string): string {
    if (!fecha) return '-';
    const date = new Date(fecha);
    if (isNaN(date.getTime())) return fecha;
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    return `${date.getFullYear()}/${mm}/${dd}`;
  }

  /**
   * Verifica si la fecha de vencimiento del preaprobado corresponde al día actual.
   * La comparación se realiza solo por fecha (yyyy-MM-dd), sin tener en cuenta la hora.
   *
   * @param fecha - Cadena de fecha de vencimiento del preaprobado.
   * @returns `true` si la fecha coincide con el día de hoy.
   */
  esVencimientoHoy(fecha: string): boolean {
    if (!fecha) return false;
    const hoy = new Date();
    const venc = new Date(fecha);
    if (isNaN(venc.getTime())) return false;
    return (
      venc.getFullYear() === hoy.getFullYear() &&
      venc.getMonth()    === hoy.getMonth()    &&
      venc.getDate()     === hoy.getDate()
    );
  }

  // ---- Acciones tabla ----

  aceptarOferta(oferta: SolicitudGestorPreaprobado): void {
    if (this.validarYRemoverVencida(oferta)) return;

    // CASO 1: El simulador está abierto para esta oferta
    if (this.ofertaSimulando === oferta) {
      if (this.montosDisponibles.length > 1 && !this.simulacionCalculada) {
        this.toastCalcularOferta(this.navService.buscarMensaje('GESTORPREAPROBADO.MSG_REQUIERE_CALCULAR_OFERTA'), 'info');
        return;
      }
      const montoMinimo = this.producto?.montoMinimo ? this.producto.montoMinimo * this.salario : 0;
      const monto: number = this.fSimulador.monto.value;
      const idFrecuencia: string = this.fSimulador.idFrecuencia.value ?? oferta.idFrecuencia;
      const ofertaSeleccionada = this.listPreAprobadosOfertaTemp.find(e => e.monto >= monto && monto >= montoMinimo);
      const preoferta: Partial<SolicitudesPreOferta> = {
        montoSolicitado: monto,
        plazo:           String(this.fSimulador.plazo.value),
        numeroCuota:     this.fSimulador.numeroCuota.value,
        idFrecuencia,
        valorCuota:      this.valorCuota,
        frecuencia:      this.frecuencias.find(f => f.idFrecuenciaProducto === idFrecuencia)?.codigoFrecuenciaProducto ?? null,
        diaCorte:        oferta.diaCorte ?? null,
        diaPago:         this.fSimulador.diaPago.value ?? oferta.diaPago ?? null,
      };
      this.confirmarYNavegar(
        oferta,
        ofertaSeleccionada?.idPreAprobadoOferta ?? oferta.idPreAprobadoOferta,
        idFrecuencia,
        preoferta
      );
      return;
    }

    // CASO 2: Simulador cerrado — usar la última simulación guardada si existe
    const ultimaOferta = this.ultimaOfertaSeleccionada.get(oferta.idPreAprobado);
    if (ultimaOferta) {
      const preoferta = this.ultimaPreofertaSimulada.get(oferta.idPreAprobado) ?? {
        montoSolicitado: oferta.monto,
        plazo:           String(oferta.plazo),
        idFrecuencia:    oferta.idFrecuencia,
        valorCuota:      oferta.valorCuota,
        frecuencia:      this.frecuencias.find(f => f.idFrecuenciaProducto === oferta.idFrecuencia)?.codigoFrecuenciaProducto ?? null,
        diaCorte:        oferta.diaCorte ?? null,
        diaPago:         oferta.diaPago ?? null,
      };
      this.confirmarYNavegar(oferta, ultimaOferta.idPreAprobadoOferta, preoferta.idFrecuencia ?? oferta.idFrecuencia, preoferta);
      return;
    }

    // CASO 3: Sin simulación previa — una sola oferta visible, pasa directo
    this.verificarMultiplesMontosYEjecutar(oferta, (preofertaSimulada) => {
      this.confirmarYNavegar(oferta, oferta.idPreAprobadoOferta, oferta.idFrecuencia, preofertaSimulada);
    });
  }

  /**
   * Muestra un diálogo de confirmación antes de navegar al flujo del preaprobado.
   * Si el usuario acepta, se ejecuta la navegación; si cancela, se mantiene en la pantalla.
   *
   * @param oferta - Oferta seleccionada (se usa su nombre de producto en el mensaje).
   * @param idPreAprobadoOferta - ID de la oferta preaprobada a usar en la ruta.
   * @param idFrecuencia - ID de la frecuencia de pago seleccionada.
   */
  private confirmarYNavegar(
    oferta: SolicitudGestorPreaprobado,
    idPreAprobadoOferta: string,
    idFrecuencia: string,
    preoferta: Partial<SolicitudesPreOferta>
  ): void {
    this.confirmationService.confirm({
      message: this.navService.buscarMensaje('GESTORPREAPROBADO.MSG_CONFIRMAR_PREAPROBADO')
        .replace('{producto}', oferta.producto),
      header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'preaprobado-confirm',
      accept: () => this.navegarAFlujo(oferta, idPreAprobadoOferta, idFrecuencia, preoferta),
      reject: () => {},
    });
  }

  private navegarAFlujo(
    oferta: SolicitudGestorPreaprobado,
    idPreAprobadoOferta: string,
    idFrecuencia: string,
    preoferta: Partial<SolicitudesPreOferta>
  ): void {
    this.preAprobadosService.obtenerPorId(oferta.idPreAprobado).subscribe({
      next: async (pre: any) => {
        const pasos = await firstValueFrom(this.proFlujoVentaService.listadoHabilitadosPorIdProductoConTipoPersona(pre.idProducto));
        const idTipoPreap = pre.idTipoPreAprobado ?? null;
        const tieneParos = pasos?.some(x =>
          x.indicadorPreaprobado &&
          (!idTipoPreap || !x.tiposPreaprobadosList?.length || x.tiposPreaprobadosList.some(t => t.idTipoPreaprobado === idTipoPreap && t.indicadorHabilitado))
        );
        if (!tieneParos) {
          this.toastCalcularOferta(this.navService.buscarMensaje('GESTORPREAPROBADO.MSG_SIN_PASOS_CONFIGURADOS'), 'warn');
          return;
        }
        if (oferta.canales && oferta.canales.length > 0) {
          pre.canales = oferta.canales;
        }
        const stateToPass = { preAprobado: pre, idPreAprobadoOferta, idFrecuencia, preoferta, tieneWallet: !!this.datosCliente.tieneWallet };
        if (this.esModal && this.sinNavegacion) {
          this.ref?.close(stateToPass);
        } else {
          this.router.navigate(['pys/gestion-comercial/flujo-venta-proceso'], {
            state: stateToPass,
          });
          if (this.esModal) {
            this.ref?.close();
          }
        }
      },
      error: () => {
        this.router.navigate(['pys/gestion-comercial/flujo-venta-proceso']);
        this.ref?.close();
      },
    });
  }

  rechazarOferta(oferta: SolicitudGestorPreaprobado): void {
    this.ofertaArechazar = oferta;
    this.abrirModalRechazo();
  }

  rechazarTodas(): void {
    this.ofertaArechazar = null;
    this.abrirModalRechazo();
  }

  vincularOferta(oferta: SolicitudGestorPreaprobado): void {
    this.resolverAccionSimple(oferta, () => this.ejecutarEnvioLink(oferta, 'PD'));
  }

  enviarOferta(oferta: SolicitudGestorPreaprobado): void {
    this.resolverAccionSimple(oferta, () => this.ejecutarEnvioLink(oferta, 'DM'));
  }

  // ---- Helpers acciones con validación de monto ----

  private resolverAccionSimple(oferta: SolicitudGestorPreaprobado, accion: () => void): void {
    if (this.validarYRemoverVencida(oferta)) return;
    if (this.ofertaSimulando === oferta) {
      if (this.montosDisponibles.length > 1 && !this.simulacionCalculada) {
        this.toastCalcularOferta(this.navService.buscarMensaje('GESTORPREAPROBADO.MSG_REQUIERE_CALCULAR_OFERTA'), 'info');
        return;
      }
      accion();
      return;
    }
    if (this.ultimaOfertaSeleccionada.has(oferta.idPreAprobado)) {
      accion();
      return;
    }
    this.verificarMultiplesMontosYEjecutar(oferta, accion);
  }

  private verificarMultiplesMontosYEjecutar(
    oferta: SolicitudGestorPreaprobado,
    accion: (preoferta: Partial<SolicitudesPreOferta>) => void
  ): void {
    this.cargando = true; // Mostrar loading mientras simulamos en background
    forkJoin([
      this.preAprobadosOfertasService.listadoPreaprobadoHabilitado(oferta.idPreAprobado),
      this.productoService.obtenerPorId(oferta.idProducto),
      this.constanteService.getByCode('CSMMLV').pipe(catchError(() => of(null))),
      this.constanteService.getByCode('CUOTRE').pipe(catchError(() => of(null))),
      this.productoFrecuenciaService.listadoPorProductoAnalizamos(oferta.idProducto).pipe(catchError(() => of([]))),
    ]).subscribe({
      next: async ([ofertas, producto, constSalario, constCuotas, frecuencias]: any[]) => {
        const salario = constSalario?.valor ? Number(constSalario.valor) : 0;
        const obtenerValorSalarios = (valor: number) => salario ? (Number(valor) / salario) : 0;

        const ofertasFiltradas = ofertas.filter((x: any) =>
          x.plazo >= producto.plazoMinimo && x.plazo <= producto.plazoMaximo &&
          obtenerValorSalarios(x.monto) >= producto.montoMinimo &&
          obtenerValorSalarios(x.monto) <= producto.montoMaximo
        );

        const montosUnicos = new Set(ofertasFiltradas.map((o: any) => o.monto));
        if (montosUnicos.size > 1) {
          this.cargando = false;
          this.toastCalcularOferta(this.navService.buscarMensaje('GESTORPREAPROBADO.MSG_REQUIERE_CALCULAR_OFERTA'), 'info');
          return;
        }

        // Simulación programática (Background Simulation)
        try {
          const diaSemanal = constCuotas?.valor ? Number(constCuotas.valor) : 0;
          const freq = frecuencias.find((f: any) => f.idLista === oferta.idFrecuencia || f.idFrecuenciaProducto === oferta.idFrecuencia);

          if (!freq) throw new Error('Frecuencia no disponible');

          const codigo = freq.codigoFrecuenciaProducto.substring(1);
          const periodicidad = Number(codigo === '7' ? diaSemanal : codigo);
          const resCuotas = (oferta.plazo * 30) / periodicidad;
          const numeroCuota = Number.isInteger(resCuotas) ? resCuotas : Math.floor(resCuotas);

          // 1. Calcular tasa real
          let tasaActual = oferta.tasaPerfil ?? oferta.tasaModalidad ?? 0;
          try {
            tasaActual = await firstValueFrom(this.preAprobadosOfertasService.calcularTasa(oferta.idPreAprobado, oferta.monto));
          } catch (_) {}

          // 2. Calcular cuota y seguros
          const valorCuota = await firstValueFrom(this.preAprobadosOfertasService.calcularCuotaOfertada({
            idProducto: oferta.idProducto,
            monto: oferta.monto,
            numeroCuotas: numeroCuota,
            codigoFrecuencia: freq.codigoFrecuenciaProducto,
            tasa: tasaActual.toString()
          }));

          const preofertaCompleta: Partial<SolicitudesPreOferta> = {
            montoSolicitado: oferta.monto,
            plazo:           String(oferta.plazo),
            idFrecuencia:    freq.idFrecuenciaProducto || oferta.idFrecuencia,
            numeroCuota,
            valorCuota,
            tasaInteres:     tasaActual,
            frecuencia:      freq.codigoFrecuenciaProducto ?? null,
            diaCorte:        oferta.diaCorte ?? null,
            diaPago:         oferta.diaPago ?? null,
          };

          this.cargando = false;
          accion(preofertaCompleta);

        } catch (error) {
          console.error('[Background Simulation Error]', error);
          this.cargando = false;
          // Fallback básico si falla la simulación completa
          accion({
            montoSolicitado: oferta.monto,
            plazo:           String(oferta.plazo),
            idFrecuencia:    oferta.idFrecuencia,
            frecuencia:      frecuencias.find((f: any) => f.idFrecuenciaProducto === oferta.idFrecuencia)?.codigoFrecuenciaProducto ?? null,
            diaCorte:        oferta.diaCorte ?? null,
            diaPago:         oferta.diaPago ?? null,
          });
        }
      },
      error: () => {
        this.cargando = false;
        this.toastCalcularOferta(this.navService.buscarMensaje('LBL_MSGERRORSERVICIO'), 'error');
      },
    });
  }

  private ejecutarEnvioLink(oferta: SolicitudGestorPreaprobado, tipo: 'PD' | 'DM'): void {
    const request$ = tipo === 'PD'
      ? this.preAprobadosService.envioNotificationEnlacePD(oferta.idPreAprobado)
      : this.preAprobadosService.envioNotificationEnlaceDM(oferta.idPreAprobado);
    const detalleMensaje = tipo === 'PD'
      ? 'PREAPROBADOMODAL.MSG_HEMOSENVIADOLINKPD'
      : 'PREAPROBADOMODAL.MSG_HEMOSENVIADOLINKBILLETERA';

    this.confirmationService.confirm({
      message: this.navService.buscarMensaje('GESTORPREAPROBADO.MSG_CONFIRMAR_NOTIFICACION')
        .replace('{producto}', oferta.producto),
      header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'preaprobado-confirm',
      accept: () => {
        this.cargando = true;
        request$.subscribe({
          next: () => {
            this.messageService.add({
              key: 'preaprobado-toast',
              severity: 'success',
              life: 10000,
              summary: this.navService.buscarMensaje('PREAPROBADOMODAL.MSG_ENLACENEVIADOCONEXITO'),
              detail: this.navService.buscarMensaje(detalleMensaje),
            });
            this.cargando = false;
          },
          error: () => {
            this.messageService.add({
              key: 'preaprobado-toast',
              severity: 'error',
              life: 10000,
              summary: this.navService.buscarMensaje('LBL_ERROR'),
              detail: this.navService.buscarMensaje('LBL_MSGERRORSERVICIO'),
            });
            this.cargando = false;
          },
        });
      },
      reject: () => {},
    });
  }

  // ---- Modal rechazo ----

  private abrirModalRechazo(): void {
    this.submittedRechazo = false;
    this.formRechazo.reset();
    this.mostrarModalRechazo = true;
  }

  cerrarModalRechazo(): void {
    this.mostrarModalRechazo = false;
    this.ofertaArechazar = null;
    this.submittedRechazo = false;
    this.formRechazo.reset();
  }

  guardarRechazo(): void {
    this.submittedRechazo = true;
    if (this.formRechazo.invalid) return;

    const { causal, comentario } = this.formRechazo.value;
    const idCausal: string = causal?.value ?? causal;

    const payload: CancelacionPreaprobado = this.ofertaArechazar
      ? { idCausal, observacion: comentario, idPreaprobado: this.ofertaArechazar.idPreAprobado }
      : { idCausal, observacion: comentario, codigoTipoDocumento: this.datosCliente.codigoTipoDocumento, numeroDocumento: this.datosCliente.numeroDocumento };

    this.preAprobadosService.cancelarPreaprobados(payload).subscribe({
      next: () => {
        this.toastCalcularOferta(
          this.navService.buscarMensaje('GESTORPREAPROBADO.MSG_RECHAZO_EXITOSO'),
          'success'
        );
        this.ofertaSimulando = null;
        this.ultimaOfertaSeleccionada.clear();
        this.cerrarModalRechazo();
        if (this.esModal && !this.perfilCrezcamos) {
          this.ref.close({ volver: true });
        } else {
          this.cargarOfertas(0, this.filasPorPagina);
        }
      },
      error: () => {
        this.toastCalcularOferta(
          this.navService.buscarMensaje('LBL_MSGERRORSERVICIO'),
          'error'
        );
      },
    });
  }

  // ---- Simulador ----

  simularOferta(oferta: SolicitudGestorPreaprobado): void {
    if (this.ofertaSimulando === oferta) {
      this.ofertaSimulando = null;
      return;
    }
    if (this.validarYRemoverVencida(oferta)) return;
    this.ofertaSimulando = oferta;
    this.valorCuota = 0;
    this.simulacionCalculada = false;
    this.submitted = false;
    this.bloqueo = false;
    this.calculando = false;
    this.cargandoSimulador = true;
    this.tasaOferta = oferta.tasaPerfil ?? oferta.tasaModalidad ?? 0;
    this.formSimulador.reset();
    this.listFrecuencias = [];
    this.montosDisponibles = [];
    this.idSeguroObligatorio = [];
    this.idPlanObligatorio = [];
    this.listPreAprobadosOfertaTemp = [];
    this.rangoMonto = '';

    forkJoin([
      this.preAprobadosOfertasService.listadoPreaprobadoHabilitado(oferta.idPreAprobado),
      this.productoService.obtenerPorId(oferta.idProducto),
      this.productoFrecuenciaService.listadoPorProductoAnalizamos(oferta.idProducto),
      this.constanteService.getByCode('CSMMLV').pipe(catchError(() => of(null))),
      this.constanteService.getByCode('CUOTRE').pipe(catchError(() => of(null))),
      this.productoSeguroService.listadoPorProductoObligatorio(oferta.idProducto).pipe(catchError(() => of([]))),
    ]).subscribe({
      next: ([ofertas, producto, frecuenciasProductos, constSalario, constDias, productoSeguros]: any[]) => {
        this.salario = constSalario?.valor ? Number(constSalario.valor) : 0;
        this.diaSemanal = constDias?.valor ? Number(constDias.valor) : 0;
        this.producto = producto;

        // Seguros obligatorios: si tiene plan se carga async sin bloquear el flujo
        if (productoSeguros && productoSeguros.length > 0) {
          if (productoSeguros[0].indicadorTasa) {
            this.idSeguroObligatorio.push(productoSeguros[0].idSeguro);
            this.finalizarCargaSimulador(ofertas, producto, frecuenciasProductos, oferta);
          } else {
            firstValueFrom(this.seguroPlanService.listadoPorIdSeguro(productoSeguros[0].idSeguro))
              .then(planes => {
                if (planes && planes.length > 0) this.idPlanObligatorio.push(planes[0].idSeguroPlan);
              })
              .catch(() => {})
              .finally(() => this.finalizarCargaSimulador(ofertas, producto, frecuenciasProductos, oferta));
          }
        } else {
          this.finalizarCargaSimulador(ofertas, producto, frecuenciasProductos, oferta);
        }
      },
      error: () => { this.cargandoSimulador = false; },
    });
  }

  private finalizarCargaSimulador(
    ofertas: PreAprobadosOfertas[],
    producto: Producto,
    frecuenciasProductos: ProductoFrecuencia[],
    oferta: SolicitudGestorPreaprobado
  ): void {
    // Frecuencias
    this.frecuencias = frecuenciasProductos.filter(f => f.indicadorHabilitado);
    this.frecuencias.forEach(f => {
      if (!this.listFrecuencias.find(x => x.value === f.idFrecuenciaProducto)) {
        this.listFrecuencias.push({ label: f.nombreFrecuenciaProducto, value: f.idFrecuenciaProducto });
      }
    });

    // Montos desde ofertas reales
    const ofertasFiltradas = this.validarListadoOfertas(ofertas, producto);
    const montosUnicos = new Set<number>();
    ofertasFiltradas.forEach(o => {
      if (!montosUnicos.has(o.monto)) {
        montosUnicos.add(o.monto);
        this.montosDisponibles.push({ label: this.formatMonto(o.monto), value: o.monto });
      }
    });

    // Helper rango monto: "Min X SMLMV - Max Y SMLMV"
    if (this.listPreAprobadosOfertaTemp.length > 0 && this.salario) {
      const min = producto.montoMinimo.toFixed(2);
      const max = (this.listPreAprobadosOfertaTemp[this.listPreAprobadosOfertaTemp.length - 1].monto / this.salario).toFixed(2);
      firstValueFrom(this.translateService.get('PREAPROBADOMODAL.LBL_MAXMIN', { value1: min, value2: max }))
        .then(txt => this.rangoMonto = txt)
        .catch(() => {});
    }

    // Valores iniciales
    if (ofertasFiltradas.length > 0) {
      this.maxMontoVal = ofertasFiltradas[0].monto;
      this.minMontoVal = this.producto?.montoMinimo ? this.producto.montoMinimo * this.salario : 0;

      this.formSimulador.get('monto')?.setValidators([
        Validators.required,
        Validators.min(this.minMontoVal),
        Validators.max(this.maxMontoVal)
      ]);
      this.formSimulador.get('monto')?.updateValueAndValidity({ emitEvent: false });

      this.formSimulador.patchValue({
        monto:           ofertasFiltradas[0].monto,
        plazo:           ofertasFiltradas[0].plazo,
        idFrecuencia:    oferta.idFrecuencia,
        diaPago:         oferta.diaPago ?? null,
      });
      this.verificarPlazoPreaprobado(ofertasFiltradas[0].monto);
      this.calcularCuota(oferta.idFrecuencia);
    } else {
      this.formSimulador.get('monto')?.setValidators([Validators.required]);
      this.formSimulador.get('monto')?.updateValueAndValidity({ emitEvent: false });
      this.formSimulador.patchValue({ idFrecuencia: oferta.idFrecuencia });
    }

    this.cargandoSimulador = false;

    if (producto?.indicadorRotativo) {
      this.calcularSimulacion();
    }
  }

  private validarListadoOfertas(ofertas: PreAprobadosOfertas[], producto: Producto): PreAprobadosOfertas[] {
    const filtered = ofertas
      .filter(x =>
        x.plazo >= producto.plazoMinimo && x.plazo <= producto.plazoMaximo &&
        this.obtenerValorSalarios(x.monto) >= producto.montoMinimo &&
        this.obtenerValorSalarios(x.monto) <= producto.montoMaximo
      )
      .sort((a, b) => b.monto - a.monto);

    this.listPreAprobadosOfertaTemp = [...filtered].sort((a, b) => a.monto - b.monto);
    return filtered;
  }

  private obtenerValorSalarios(valor: number): number {
    return this.salario ? (Number(valor) / this.salario) : 0;
  }

  verificarPlazoPreaprobado(monto: number): void {
    const montoCalculo = monto ? Number(monto) : null;
    this.simulacionCalculada = false;
    this.valorCuota = 0;
    const montoMinimo = this.producto?.montoMinimo ? this.producto.montoMinimo * this.salario : 0;
    let registro: PreAprobadosOfertas = null;
    for (const e of this.listPreAprobadosOfertaTemp) {
      if (e.monto >= montoCalculo && montoCalculo >= montoMinimo) {
        registro = e;
        break;
      }
    }
    this.fSimulador.plazo.setValue(registro?.plazo ?? null);
    if (registro?.plazo && this.fSimulador.idFrecuencia.value) {
      this.calcularCuota(this.fSimulador.idFrecuencia.value);
    }
    this.bloqueo = false;
  }

  calcularCuota(idFrecuencia: string): void {
    const frecuencia = this.frecuencias.find(f => f.idFrecuenciaProducto === idFrecuencia);
    if (!frecuencia) return;
    this.actualizarMaxCuotas(frecuencia);
    this.simulacionCalculada = false;
    this.valorCuota = 0;
    if (!this.fSimulador.plazo.value) return;
    const codigo = frecuencia.codigoFrecuenciaProducto.substring(1);
    const result = (this.fSimulador.plazo.value * 30) / Number(codigo === '7' ? this.diaSemanal : codigo);
    this.fSimulador.numeroCuota.setValue(Number.isInteger(result) ? result : null);
    this.fSimulador.numeroCuota.updateValueAndValidity({ emitEvent: false });
  }

  private actualizarMaxCuotas(frecuencia: ProductoFrecuencia): void {
    if(frecuencia && frecuencia.codigoFrecuenciaProducto){
      const codigo = frecuencia.codigoFrecuenciaProducto.substring(1);
      const periodicidad = Number(codigo === '7' ? this.diaSemanal : codigo);
      this.maxCuotas = !this.producto?.plazoMaximo ? 0 : Math.floor((this.producto.plazoMaximo * 30) / periodicidad);
      this.minCuotas = !this.producto?.plazoMinimo ? 0 : Math.floor((this.producto.plazoMinimo * 30) / periodicidad);
    } else {
      this.maxCuotas = 0;
      this.minCuotas = 0;
    }
    this.fSimulador.numeroCuota.setValidators([
      Validators.required,
      Validators.min(this.minCuotas),
      Validators.max(this.maxCuotas),
    ]);
    this.fSimulador.numeroCuota.updateValueAndValidity({ emitEvent: false });
  }

  calcularPlazo(): void {
    if (this.fSimulador.numeroCuota.value && this.fSimulador.idFrecuencia.value) {
      const frecuencia = this.frecuencias.find(f => f.idFrecuenciaProducto === this.fSimulador.idFrecuencia.value);
      if (frecuencia) {
        const codigo = frecuencia.codigoFrecuenciaProducto.substring(1);
        const result = (Number(this.fSimulador.numeroCuota.value) * Number(codigo === '7' ? this.diaSemanal : codigo)) / 30;
        if (this.producto?.plazoMaximo && result > this.producto.plazoMaximo) {
          this.fSimulador.plazo.setValue(null);
          this.fSimulador.numeroCuota.setValue(null);
        } else {
          this.fSimulador.plazo.setValue(result);
        }
      }
    }
    this.simulacionCalculada = false;
    this.valorCuota = 0;
    this.bloqueo = false;
  }

  bloquearCalcular(): void {
    this.bloqueo = true;
  }

  onMontoInputBlur(): void {
    if (this.producto?.indicadorRotativo) {
      this.simulacionCalculada = false;
      // setTimeout para que PrimeNG termine de clampear y actualizar el formControl antes de calcular
      setTimeout(() => this.calcularSimulacion());
    } else {
      this.verificarPlazoPreaprobado(this.fSimulador.monto.value);
    }
  }

  onMontoDropdownChange(): void {
    if (this.producto?.indicadorRotativo) {
      this.simulacionCalculada = false;
      this.calcularSimulacion();
    } else {
      this.bloquearCalcular();
      this.verificarPlazoPreaprobado(this.fSimulador.monto.value);
    }
  }

  ciclarHelper(event: MouseEvent): void {
    const small = event.currentTarget as HTMLElement;
    const span = small.querySelector('span') as HTMLElement;
    if (!span) return;
    const overflow = span.scrollWidth - small.clientWidth;
    if (overflow <= 0) return;
    small.style.setProperty('--ciclar-px', `-${overflow}px`);
    small.classList.remove('simulador-maximo--ciclar');
    void small.offsetWidth; // fuerza reflow para reiniciar la animación
    small.classList.add('simulador-maximo--ciclar');
    small.addEventListener('animationend', () => small.classList.remove('simulador-maximo--ciclar'), { once: true });
  }

  async calcularSimulacion(): Promise<void> {
    this.submitted = true;
    // En modo input (un solo monto) y no rotativo: el usuario puede llegar directo
    // sin blur, recalcular plazo/cuotas antes de validar
    if (this.montosDisponibles.length <= 1 && !this.producto?.indicadorRotativo) {
      this.verificarPlazoPreaprobado(this.fSimulador.monto.value);
    }
    if (this.fSimulador.monto.invalid) return;
    if (!this.producto?.indicadorRotativo && this.fSimulador.numeroCuota.invalid) return;

    this.calculando = true;

    // Calcular tasa real
    try {
      this.tasaOferta = await firstValueFrom(
        this.preAprobadosOfertasService.calcularTasa(this.ofertaSimulando.idPreAprobado, this.fSimulador.monto.value)
      );
    } catch (_) {
      this.tasaOferta = this.ofertaSimulando.tasaModalidad ?? this.ofertaSimulando.tasaPerfil ?? 0;
    }

    // Producto rotativo: no hay cuota
    if (this.producto?.indicadorRotativo) {
      this.simulacionCalculada = true;
      this.calculando = false;
      return;
    }

    const frecuencia = this.frecuencias.find(f => f.idFrecuenciaProducto === this.fSimulador.idFrecuencia.value);
    if (!frecuencia) { this.calculando = false; return; }

    this.preAprobadosOfertasService.calcularCuotaOfertada({
      idProducto: this.ofertaSimulando.idProducto,
      monto: this.fSimulador.monto.value,
      numeroCuotas: this.fSimulador.numeroCuota.value,
      codigoFrecuencia: frecuencia.codigoFrecuenciaProducto,
      tasa: (this.tasaOferta || (this.ofertaSimulando.tasaPerfil ?? this.ofertaSimulando.tasaModalidad ?? 0)).toString()
    }).subscribe({
      next: (resp) => {
        this.valorCuota = resp;
        this.simulacionCalculada = true;
        this.calculando = false;
      },
      error: () => {
        this.toastCalcularOferta(this.navService.buscarMensaje('LBL_MSGERRORSERVICIO'), 'error');
        this.calculando = false;
      },
    });
  }

  guardarSimulacion(): void {
    const monto: number = this.fSimulador.monto.value;
    const plazo: number = this.fSimulador.plazo.value;
    const idFrecuencia: string = this.fSimulador.idFrecuencia.value;
    const montoMinimo = this.producto?.montoMinimo ? this.producto.montoMinimo * this.salario : 0;

    // Encontrar la PreAprobadosOfertas que corresponde al monto/plazo seleccionado
    const ofertaSeleccionada = this.listPreAprobadosOfertaTemp.find(e =>
      e.monto >= monto && monto >= montoMinimo
    ) ?? null;

    const ofertaActual = this.ofertaSimulando;

    if (ofertaActual && ofertaSeleccionada) {
      // Guardar última oferta modificada para este preaprobado
      this.ultimaOfertaSeleccionada.set(ofertaActual.idPreAprobado, ofertaSeleccionada);
      // Guardar preoferta simulada para llevar a datos básicos
      const frecSimulada = this.frecuencias.find(f => f.idFrecuenciaProducto === idFrecuencia);
      this.ultimaPreofertaSimulada.set(ofertaActual.idPreAprobado, {
        montoSolicitado: monto,
        plazo:           String(plazo),
        numeroCuota:     this.fSimulador.numeroCuota.value,
        idFrecuencia:    idFrecuencia ?? ofertaActual.idFrecuencia,
        valorCuota:      this.valorCuota,
        frecuencia:      frecSimulada?.codigoFrecuenciaProducto ?? null,
        diaCorte:        ofertaActual.diaCorte ?? null,
        diaPago:         this.fSimulador.diaPago.value ?? ofertaActual.diaPago ?? null,
      });

      // Actualizar el registro temporalmente en la tabla
      const idx = this.ofertasFiltradas.indexOf(ofertaActual);
      if (idx !== -1) {
        const frecuenciaLabel = this.listFrecuencias.find(f => f.value === idFrecuencia)?.label ?? ofertaActual.frecuencia;
        this.ofertasFiltradas[idx] = {
          ...ofertaActual,
          idPreAprobadoOferta: ofertaSeleccionada.idPreAprobadoOferta,
          monto,
          plazo,
          idFrecuencia: idFrecuencia ?? ofertaActual.idFrecuencia,
          frecuencia: frecuenciaLabel,
          valorCuota: this.valorCuota,
        };
      }
    }

    this.ofertaSimulando = null;
    this.simulacionCalculada = false;
    this.submitted = false;
    this.formSimulador.reset();
  }

  // ---- Utilidades ----

  private validarYRemoverVencida(oferta: SolicitudGestorPreaprobado): boolean {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const venc = new Date(oferta.fechaFinVigenciaString);
    venc.setHours(0, 0, 0, 0);
    if (venc >= hoy) return false;

    this.toastCalcularOferta(
      this.navService.buscarMensaje('GESTORPREAPROBADO.MSG_OFERTA_VENCIDA'),
      'warn'
    );
    if (this.ofertaSimulando === oferta) {
      this.ofertaSimulando = null;
    }
    this.ultimaOfertaSeleccionada.delete(oferta.idPreAprobado);
    this.ofertasFiltradas = this.ofertasFiltradas.filter(o => o !== oferta);
    this.totalRegistros = Math.max(0, this.totalRegistros - 1);
    return true;
  }

  toastCalcularOferta(mensaje: string, severity: string): void {
    this.messageService.add({
      key: 'preaprobado-toast',
      severity,
      life: 10000,
      summary: this.navService.buscarMensaje('LBL_INFORMACION'),
      detail: mensaje,
    });
  }

  confirmarContinuarPreaprobado(oferta: SolicitudGestorPreaprobado): void {
    this.confirmationService.confirm({
      message: this.navService.buscarMensaje('GESTORPREAPROBADO.MSG_CONFIRMAR_PREAPROBADO')
        .replace('{producto}', oferta.producto),
      header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'preaprobado-confirm',
      accept: () => console.log('Continuar con preaprobado', oferta),
      reject: () => {},
    });
  }

  confirmarEnviarNotificacion(oferta: SolicitudGestorPreaprobado): void {
    this.confirmationService.confirm({
      message: this.navService.buscarMensaje('GESTORPREAPROBADO.MSG_CONFIRMAR_NOTIFICACION')
        .replace('{producto}', oferta.producto),
      header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'preaprobado-confirm',
      accept: () => console.log('Enviar notificación', oferta),
      reject: () => {},
    });
  }

  cerrar(): void {
    this.ref.close({ volver: true });
  }
}
